import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { InnerBox } from '../../../components/Tutor/style';
import CustomTextarea from '../../CustomTextarea';
import { AnswerTop } from './style';
import Text from '../../Text';
import CustomToggle from '../../CustomToggle';
import CTA from '../../CTA';
import {
  DEL_ANSWER,
  UPDATE_ANSWER,
} from '../../../../app/redux/actions/tutors';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const Answer = ({
  mediaIsPhone,
  index,
  questionKey,
  answerKey,
  quiz,
  updateAnswer,
  delAnswer,
}) => {
  const [answer, setAnswer] = useState({});

  useEffect(() => {
    if (quiz[questionKey]?.choice_answers && answerKey) {
      setAnswer(quiz[questionKey]?.choice_answers[answerKey]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quiz, answerKey]);

  return (
    <InnerBox className="mb-4">
      <AnswerTop>
        <Text type="h3" tag="label" htmlFor={`enter-answer-${index}`}>Risposta {index}</Text>
        {!mediaIsPhone && (
          <>
            <Text type="b3" tag="label" htmlFor={`correct-answer-${index}`}>Risposta corretta</Text>
            <CustomToggle
              id={`correct-answer-${index}`}
              checked={!!answer?.is_correct}
              onClick={() =>
                updateAnswer(
                  questionKey,
                  answerKey,
                  'is_correct',
                  !answer?.is_correct
                )
              }
            />
          </>
        )}
        {index > 1 && (
          <CTA
            type="tertiary"
            btnText="Elimina"
            icon="trash-01"
            bottomRight
            onClick={() => delAnswer(questionKey, answerKey)}
          />
        )}
      </AnswerTop>
      {mediaIsPhone && (
        <div className="d-flex mb-3">
          <Text type="b3" tag="label" htmlFor={`correct-answer-${index}`}>Risposta corretta</Text>
          <CustomToggle
            id={`correct-answer-${index}`}
            checked={!!answer?.is_correct}
            onClick={() =>
              updateAnswer(
                questionKey,
                answerKey,
                'is_correct',
                !answer?.is_correct
              )
            }
          />
        </div>
      )}
      <CustomTextarea
        id={`enter-answer-${index}`}
        placeholder="Inserisci la risposta"
        minHeight={146}
        mb={0}
        value={answer?.answer}
        onChange={(value) =>
          updateAnswer(questionKey, answerKey, 'answer', value)
        }
      />
    </InnerBox>
  );
};

Answer.propTypes = {
  mediaIsPhone: PropTypes.bool,
  index: PropTypes.number,
  questionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  answerKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  quiz: PropTypes.object,
  updateAnswer: PropTypes.func,
  delAnswer: PropTypes.func,
};

export default connect(
  (state) => {
    const { quiz } = state.tutors.quiz;
    return { quiz };
  },
  (dispatch) => ({
    updateAnswer: (qId, aId, field, value) =>
      dispatch({ type: UPDATE_ANSWER, qId, aId, field, value }),
    delAnswer: (questionId, answerId) =>
      dispatch({ type: DEL_ANSWER, questionId, answerId }),
  })
)(withMediaQueries(Answer));
